// 인증 관련 Zod 유효성 검사 스키마
import { z } from "zod";
import { USER_GRADES } from "../constants/auth";

/**
 * 로그인 요청 스키마
 */
export const loginSchema = z.object({
  id: z.string().min(1, "아이디를 입력해주세요").max(50, "아이디는 50자 이하로 입력해주세요"),
  pwd: z
    .string()
    .min(1, "비밀번호를 입력해주세요")
    .max(100, "비밀번호는 100자 이하로 입력해주세요"),
});

/**
 * 계정 생성 요청 스키마
 */
export const createUserSchema = z.object({
  id: z
    .string()
    .min(3, "아이디는 3자 이상이어야 합니다")
    .max(50, "아이디는 50자 이하로 입력해주세요")
    .regex(/^[a-zA-Z0-9_]+$/, "아이디는 영문, 숫자, 언더스코어만 사용 가능합니다"),
  name: z.string().min(1, "이름을 입력해주세요").max(50, "이름은 50자 이하로 입력해주세요"),
  pwd: z
    .string()
    .min(8, "비밀번호는 8자 이상이어야 합니다")
    .max(100, "비밀번호는 100자 이하로 입력해주세요"),
  grade: z.enum(USER_GRADES as unknown as [string, ...string[]], {
    message: "올바른 직급을 선택해주세요",
  }),
  companyId: z.string().min(1, "회사를 선택해주세요"),
  phone: z.string().optional(),
  email: z.string().email("올바른 이메일 형식이 아닙니다").optional().or(z.literal("")),
});

/**
 * 로그인 입력 타입
 */
export type LoginInput = z.infer<typeof loginSchema>;

/**
 * 계정 생성 입력 타입
 */
export type CreateUserInput = z.infer<typeof createUserSchema>;
